import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';
import TarotDeck from './deck';
import moment from 'moment';

class Component extends BaseComponent {
    render({ deck, user, positions, cards, interps, route, teeup }) {
        const position = /^tarot-reading/.test(route) && route.match(/^tarot-reading\/(.+)$/)[1];
        const current = positions.map(i => i.position).indexOf(position);

        if (deck && interps && cards && positions.length && current !== -1) {
            const next = (current < cards.length - 1) ? current + 1 : 0;
            const prev = current == 0 ? cards.length - 1 : current - 1;
            const nextCard = cards[next];
            const prevCard = cards[prev];
            const attribution_href = '/tarot/decks/' + deck.slug;
            const nav_previous_href = '#tarot-reading/' + positions[prev].position;
            const nav_next_href = '#tarot-reading/' + positions[next].position;

            return (
                <tarot-reading-sample-interp>
                    <header>
                        <time class='pre-header' dateTime={moment().toString}>{moment().format('MMMM Do, YYYY')}</time>
                        <h1 class='reading-header fancy-title'>{user.username}'s Tarot Reading</h1>
                        <p class='subject-set'>your question: {this.props.subject || 'unspoken'}</p>
                    </header>
                    <section>
                        <ol class='interp'>
                            {positions.map(this.renderPosition)}
                        </ol>
                        <p class='copyright attribution clear'>
                            <a href={attribution_href}>{deck.name}</a> deck {deck.deck_vendor_copyright}
                        </p>
                    </section>
                    <section class='interp-main'>
                        <h1 class='interp-main-header'>{deck.cards[cards[current]].name}</h1>
                        <div class='interp-header'>
                            <h2>{interps[current].position_name}: </h2>
                            <p class='interp-header'>{interps[current].interp_header}</p>
                        </div>
                        <p dangerouslySetInnerHTML={{__html:interps[current].interp}} />
                        <nav>
                            <ul>
                                <li class='nav-previous'>
                                    <a
                                      href={nav_previous_href}
                                      class='text-link-undecorated'
                                      data-action='Click-Last-Card'
                                    >
                                        <h5>Last Card:</h5>
                                        <span class='text-link' data-action='Click-Last-Card'>
                                            {deck.cards[prevCard].name}
                                        </span>
                                    </a>
                                </li>
                                <li class='nav-next' data-action='Click-Next-Card'>
                                    <a href={nav_next_href} class='text-link-undecorated'>
                                        <h5>Next Card:</h5>
                                        <span class='text-link' data-action='Click-Last-Card'>
                                            {deck.cards[nextCard].name}
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </section>
                    <section>
                        <br />
                        <h1 class='fancy-title'>Need More Clarity?</h1>
                        <div class='upsell'>
                            <p>Continue your reading by selecting your final 7 cards:</p>
                            <p class='card-next'>choose recent past card:</p>
                            <a href='#tarot-reading/celtic-cross' data-action='Click-Upsell-Deck'>
                                <TarotDeck spread={deck.spread} upsell upc={teeup.upsell_upc} />
                            </a>
                        </div>
                    </section>
                </tarot-reading-sample-interp>
            );
        }

        return null;
    }

    renderPosition = (position, i) => {
        const route_position = /^tarot-reading/.test(this.props.route)
            && this.props.route.match(/^tarot-reading\/(.+)$/)[1];
        const className = position.position == route_position ? 'active' : '';
        const href = '#tarot-reading/' + position.position;
        const action = 'Click-' + position.position + '-Interp';
        const src='https://gfx.tarot.com/images/site/decks/' + this.props.deck.slug +
            '/full_size/' + this.props.cards[i] + '.jpg';

        return (
            <li class={className}>
                <h3 class='card-next'>{position.title.replace(/\/.*/, '')}</h3>
                <a href={href}>
                    <img
                      alt={this.props.deck.cards[this.props.cards[i]].name}
                      class='interp-card spread-card'
                      data-action={action}
                      src={src}
                    />
                </a>
            </li>
        );
    }

    scrollTop = () => {
        const elTop = $(this.parent).offset().top;
        const topBarHeight = $('.js-top_bar, .user_bar').outerHeight();
        const currentScroll = $(window).scrollTop();
        const topScroll = elTop - topBarHeight;

        if (currentScroll > topScroll) {
            window.scrollTo(0, topScroll);
        }
    }
}

const mapStateToProps = (state) => ({
    deck: state.deck,
    user: state.user,
    subject: state['tarot-reading'].subject,
    positions: state['tarot-reading'].positions,
    cards: state['tarot-reading'].cards,
    interps: state['tarot-reading'].interps,
    route: state.route,
    teeup: state.product.teeup,
});

export default connect(mapStateToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/tarot-readings/tarot-reading/sample-interp.js